var map = {
	"./menu-ico-2-sel.png": 303,
	"./menu-ico-2.png": 304,
	"./menu-ico-3-sel.png": 696,
	"./menu-ico-3.png": 697,
	"./menu-ico-4-sel.png": 698,
	"./menu-ico-4.png": 699,
	"./menu-ico-5-sel.png": 700,
	"./menu-ico-5.png": 701
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 695;